import { render, staticRenderFns } from "./BetgameImprint.vue?vue&type=template&id=69a36100&scoped=true"
import script from "./BetgameImprint.vue?vue&type=script&lang=js"
export * from "./BetgameImprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a36100",
  null
  
)

export default component.exports